export default (fields) => {
  const structure = {};
  fields.forEach(field =>
    structure[field] = function (item) {
      return item[field + 'Id'] || item[field];
    }
  );
  return structure;
};



// WEBPACK FOOTER //
// ./~/virgo/src/structures/fieldsToStructure.js